import { FC } from 'react';

import getClassNames from 'src/common/utils/getClassNames';
import classNames from 'classnames';
import styles from './Divider.module.scss';

export const variants = [
  'solid',
  'dashed',
] as const;
export type Variant = typeof variants[number];

export type DividerProps = {
  size?: 1 | 2;
  variant?: Variant;
  withMargin?: boolean;
};

const Divider: FC<DividerProps> = ({
  size = 1,
  variant = variants[0],
  withMargin = true,
}) => (
  <hr
    className={getClassNames(styles, 'root', classNames(variant, { withMargin }))}
    style={{ borderWidth: `${size}px` }}
  />
);

export default Divider;
